module.exports = __webpack_public_path__ + "img/ico_service_off.1331feec.svg";